import { forwardRef } from 'react';

import { Box } from '@base-app';
import { DropdownListItemProps } from './DropdownList.types';
import { DropdownListItemStyled } from './DropdownList.styles';
import { StyledCheckIcon } from './DropdownListItem.styles';

const DropdownListItem = forwardRef<HTMLLIElement | null, DropdownListItemProps>(
  (
    { item, selected, selectableMode, onClick, role = 'listitem', isFakeFocus, testId }: DropdownListItemProps,
    liRef,
  ): JSX.Element => {
    return (
      <DropdownListItemStyled
        data-testid={testId}
        ref={liRef}
        role={role}
        onClick={onClick}
        className={selected === true ? 'selected' : ''}
        css={isFakeFocus ? { backgroundColor: '$coolGray300' } : {}}
      >
        <Box as="span">{item.label}</Box>
        {selectableMode === true && selected === true && (
          <Box
            as="span"
            css={{
              paddingLeft: '$3',
              top: '2px',
              position: 'relative',
              alignContent: 'normal',
            }}
          >
            <StyledCheckIcon />
          </Box>
        )}
      </DropdownListItemStyled>
    );
  },
);

export default DropdownListItem;
DropdownListItem.displayName = 'DropdownListItem';
